import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { BrowserMultiFormatReader, Result } from '@zxing/library';
import { ToasterService } from '../../service/toaster.service';

@Component({
  selector: 'app-barcode-reader',
  imports: [CommonModule],
  templateUrl: './barcode-reader.component.html',
  styleUrl: './barcode-reader.component.css'
})
export class BarcodeReaderComponent {
  @ViewChild('videoElement', { static: false }) videoElement!: ElementRef;
  @Output() onRead = new EventEmitter<string>();
  @Output() onTurnOff = new EventEmitter();
  private codeReader: BrowserMultiFormatReader;
  readCode: boolean = false;
  videoStream: MediaStream | null = null;
  barcodeValue: string = '';

  constructor(private toasterService: ToasterService) {
    this.codeReader = new BrowserMultiFormatReader();
  }

  start() {
    this.readCode = true;
    this.startScanner();
  }

  startScanner() {
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        this.videoStream = stream;
        this.videoElement.nativeElement.srcObject = stream;
        this.codeReader.decodeFromVideoDevice('', this.videoElement.nativeElement, (result: Result, error: any) => {
          if (result) {
            this.barcodeValue = result.getText();
            this.onRead.emit(this.barcodeValue);
            this.turnOff();
          }
        });
      })
      .catch((err) => {
        this.toasterService.triggerAlert('Ocorreu um erro ao acessar a câmera. Tente novamente', 'error');
        console.error('Erro ao acessar a câmera:', err);
      });
  }


  turnOff() {
    // Desliga o scanner e libera os recursos quando o componente for destruído
    if (this.videoStream) {
      const tracks = this.videoStream.getTracks();
      tracks.forEach(track => track.stop());
    }
    this.codeReader.reset();
    this.readCode = false;
    this.onTurnOff.emit();
  }
}
